import { factory, getResponseCamelization } from '@repo-level/core-front';
import { CMSApiBase, buildCmsUrl, getResponseCMS } from './base';
import { CMS_URL, isCMSV3 } from 'helpers/conf';

export interface PrivacyPolicyApi extends CMSApiBase {
  title: string;
  titleH1: string;
  text: string;
  textLibergos?: string;
  effectiveFrom: string;
  lastUpdated: string;
  tableHtml?: string;
}

export const privacyPolicyV3 = factory((r) => (lang: string) =>
  r<PrivacyPolicyApi>('get', `${CMS_URL}/privacy-policy?_locale=${lang}`)
);

export const privacyPolicyV4 = factory((r) => (lang: string) =>
  r<PrivacyPolicyApi>(
    'get',
    buildCmsUrl({ path: 'privacy-policy', lang }),
    undefined,
    { transformResponse: [getResponseCamelization(), getResponseCMS] }
  )
);

export const privacyPolicy = isCMSV3 ? privacyPolicyV3 : privacyPolicyV4;
